// extracted by mini-css-extract-plugin
export var banner = "_q2-0";
export var settingRow = "_q2-2";
export var titleIcon = "_q2-1";